<template>
  <div id="app">
    <router-view />
  </div>
</template>


<script>

export default {
  name: "App",
  components: {},
  data() {
    return {
      f5Count: 0,
      refreshCount: 0,
      beforeunloadCount: 0,
      logs: []
    };
  },

  // created() { },
  // mounted() {
  //   this.setupEventListeners()
  // },
  // beforeDestroy() {
  //   this.removeEventListeners()
  // },
  // methods: {
  //   setupEventListeners() {
  //     window.addEventListener('keydown', this.handleKeyDown)
  //     window.addEventListener('beforeunload', this.handleBeforeUnload)
  //   },

  //   removeEventListeners() {
  //     window.removeEventListener('keydown', this.handleKeyDown)
  //     window.removeEventListener('beforeunload', this.handleBeforeUnload)
  //   },
  //   handleKeyDown(event) {
  //     // F5键
  //     if (event.key === 'F5' || event.keyCode === 116) {
  //       event.preventDefault()
  //       this.f5Count++
  //       this.addLog('F5键被按下')
  //       this.saveData()
  //     }

  //     // Ctrl+R 或 Cmd+R
  //     if ((event.ctrlKey || event.metaKey) && event.key === 'r') {
  //       event.preventDefault()
  //       this.refreshCount++
  //       this.addLog('刷新快捷键被按下')
  //       this.saveData()
  //     }
  //   },

  //   handleBeforeUnload(event) {
  //     this.beforeunloadCount++
  //     this.addLog('页面即将刷新/关闭')
  //     this.saveData()

  //     // 可选：显示确认对话框
  //     // event.preventDefault()
  //     // event.returnValue = '确定要离开此页面吗？'
  //   },

  //   addLog(message) {

  //   },

  //   saveData() {
  //     if (this.$route.query.searchCategoryId) {
  //       this.$router.replace('/index')
  //     }

  //   }

  // },
};
</script>


<style lang="less">
body p {
  padding: 0px;
  margin: 0px;
}
</style>
